import React, { useContext } from 'react';
import PriceItem from './components/PriceItem';
import {
	DishFullInfoContext,
	IDishFullInfoContext,
} from '../../../../../../../../dishFullInfoState/dishFullInfoContext';
import style from './AdditionallySection.module.scss';

const AdditionallySection: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);
	return (
		<div className={style.container}>
			{dishForFullInfo?.restaurantsDishes.map((el) => (
				<PriceItem key={el.restaurantId} data={el} />
			))}
		</div>
	);
};

export default AdditionallySection;
